import { useTranslation } from 'react-i18next';
import './App.css';
import { useEffect } from 'react';
import moment from 'moment';
import { ThemeProvider } from '@emotion/react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { muiTheme } from '@styles/MuiTheme';
import GlobalStyles from './styles/GlobalStyles/GlobalStyles';
import { Alert, DialogConfirm, Loading } from '@components/commons';
import AppRoutes from './AppRoutes';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  return (
    <div className='App'>
      <Router>
        <ThemeProvider theme={muiTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <GlobalStyles>
              <AppRoutes />
              <DialogConfirm />
              <Alert />
              <Loading />
            </GlobalStyles>
          </LocalizationProvider>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
